import { AssignablePassengerOption } from "components/AncillarySelection/AncillarySelection";
import { SetBookingPayload } from "Pages/AvailableFaresPage";
import React, { Fragment, useEffect, useMemo, useState, useCallback } from "react";
import { Alert } from "reactstrap";
import { AvailableFareModel } from "WebApiClient";
import { ServiceAddObj } from "./AncillariesModal";
import FareCalculation from "./Fare.Calculation";
import FareHeader from "./Fare.Header";
import FareInfoBox from "./Fare.InfoBox";
import { FareFilterApplicability } from "./FareFilter.Applicability";
import _ from "lodash";
import { AvailableFaresFare } from "components/AvailableFares/component/AvailableFares.Fares";
import { toast } from "react-toastify";
import { useFareManager } from "hooks/useFareManager";
import { useFareModals } from "hooks/useFareModals";
import "react-multi-carousel/lib/styles.css";
import FareModals from "./FareModals";
import FareLegList from "./FareLegList";
import FareActions from "./FareActions";
interface IFareProps {
  ShowAllLegsActive: boolean;
  ShowAllFlightTimesActive: boolean;
  ShowAllCalculationActive: boolean;
  FareData: AvailableFareModel;
  Applicability?: FareFilterApplicability;
  IsFareBooking: boolean;
  BookFare?: (payload: SetBookingPayload) => void;
  SelectedConnections?: number[];
  SelectConnection?: (legIndex: number, ConnectionIndex: number) => void;
  AddedServices?: ServiceAddObj[];
  SetAddedServices?(services: ServiceAddObj[]): void;
  BookPassengers?: AssignablePassengerOption[];
  ShowCalcDebugger: boolean;
  myRefs?: any;
  key?: any;
  isActivate?: boolean;
  TotalFare: AvailableFaresFare[];
  fareLegBoolArray: any;
  setFareLegBoolArray: any;
  isScrollF: string;
  setShowAllFlightTimesActive?: any;
}

const Fare: React.FC<IFareProps> = (props) => {
  const OriginalFareIndex: number = props.FareData.fareIndex;
  const [renderError, setRenderError] = useState(false);
  const [Status, setStatus] = useState(false);
  const [showLegs, setShowLegs] = useState(false);
  const [showCalculation, setShowCalculation] = useState(false);
  const [searchFlightNumber, setSearchFlightNumber] = useState<string[][]>([]);
  const [internaladdedServices, setInternalAddedServices] = useState<ServiceAddObj[]>([]);
  const [width, setWidth] = useState(window.innerWidth);
  const { modals, toggleModal } = useFareModals();
  const PlatingCarriers = useMemo(() => props.FareData.legs.map((e) => e.platingCarrier!), [props.FareData.legs]);
  const DistinctPlatingCarriers = useMemo(() => {
    const result = [];
    const map = new Map();
    for (const item of PlatingCarriers) {
      if (!map.has(item.code!)) {
        map.set(item.code!, true);
        result.push(item);
      }
    }
    return result;
  }, [PlatingCarriers]);

  const ShowFare = props.Applicability ? props.Applicability.Applicable : true;
  const _addedServices = props.AddedServices ?? internaladdedServices;
  const _setAddedServices = props.SetAddedServices ?? ((services: ServiceAddObj[]) => setInternalAddedServices(services));

  const AssignablePassengers = useMemo(() => {
    if (props.BookPassengers) return props.BookPassengers;
    const p = props.FareData.bookingPassengers!;
    return p.map((element, index) => {
      const pData = element.bookingData;
      const useCustomLabel = (pData.firstName || "").length > 0 || (pData.lastName || "").length > 0;
      const label = useCustomLabel
        ? `${pData.title ?? ""} ${pData.firstName ?? ""} ${pData.lastName ?? ""} (${pData.passengerType})`
        : `${pData.passengerType} ${index + 1}`;
      return {
        Index: index,
        Label: label,
        PassengerType: pData.passengerType,
      };
    });
  }, [props.BookPassengers, props.FareData.bookingPassengers]);

  const responsive = useMemo(() => ({
    superLargeDesktop: { breakpoint: { max: 4000, min: 1600 }, items: 5 },
    desktop: { breakpoint: { max: 1600, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  }), []);


  const {
    internalSelectedConnections,
    setInternalSelectedConnections,
    SetSelectedConnection,
    GetSelectedConnectionIndexByLegIndex,
    showFlightTimes,
    ToggleFlightTimes,
    setShowFlightTimes
  } = useFareManager({
    fareData: props.FareData,
    applicability: props.Applicability,
    selectedConnections: props.SelectedConnections,
    selectConnection: props.SelectConnection,
  });

  const visibleItems = useMemo(() => {
    if (width >= 1600) return responsive.superLargeDesktop.items;
    if (width >= 1024) return responsive.desktop.items;
    if (width >= 464) return responsive.tablet.items;
    return responsive.mobile.items;
  }, [width, responsive]);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    try {
      if (internalSelectedConnections.length === 0) {
        const initialSelection = props.FareData.legs.map(() => 0);
        setInternalSelectedConnections(initialSelection);
        return;
      }

      internalSelectedConnections.forEach((val, index) => {
        const applicable = props.Applicability?.ApplicableConnections?.[index];
        if (applicable && !applicable.includes(val)) {
          SetSelectedConnection(index, applicable[0]);
        }
      });
    } catch (error) {
      console.error(
        `Error in fare ${props.FareData.identifier.fareIndex} during useEffect connection setup.`,
        error
      );
      setRenderError(true);
    }
  }, [
    internalSelectedConnections,
    props.Applicability?.ApplicableConnections,
    props.FareData.legs.length,
  ]);

  useEffect(() => {
    setShowLegs(props.ShowAllLegsActive);
  }, [props.ShowAllLegsActive]);

  useEffect(() => {
    setShowFlightTimes(props.ShowAllFlightTimesActive);
  }, [props.ShowAllFlightTimesActive]);

  useEffect(() => {
    setShowCalculation(props.ShowAllCalculationActive);
  }, [props.ShowAllCalculationActive]);

  const ToggleLegs = (fareIndexSingle: number, legBoolString: string) => {
    if (Array.isArray(props.fareLegBoolArray) && props.fareLegBoolArray.length > 0) {
      const updatedFareLegBoolArray = props.fareLegBoolArray.map(
        (item: { fareIndex: number; fareLeg: boolean }, index: any) =>
          index === fareIndexSingle
            ? { ...item, fareLeg: legBoolString === "showLeg" ? !item.fareLeg : true }
            : item
      );
      props.setFareLegBoolArray(updatedFareLegBoolArray);
    } else {
      setShowLegs(!showLegs);
    }
  };

  const scrollToBook = (fareIndex: number) => {
    props.myRefs.current[fareIndex]?.scrollIntoView({ behavior: 'smooth' });
    ToggleLegs(fareIndex, "scrollLeg");
  };
  const GetSelectedConnectionIndexByLegIndexUpsell = (faredata: any, legIndex: number): number => props.SelectedConnections === undefined ? findConnectionIndices(faredata.Fare, searchFlightNumber)[legIndex] : props.SelectedConnections[legIndex];

  const findConnectionIndices = (fare: AvailableFareModel, flightNumbers: string[][]) =>
    flightNumbers.map(legFlightNumbers => {
      let foundIndex: any = -1;
      for (const leg of fare.legs) {
        for (const connection of leg.connections) {
          const allMatch = legFlightNumbers.every(flightNumber =>
            connection.segments.some(segment => segment.flightNumber === flightNumber)
          );
          if (allMatch) {
            foundIndex = connection?.connectionIdentifier?.connectionIndex;
            break;
          }
        }
        if (foundIndex !== -1) break;
      }
      return foundIndex;
    });

  const [upscaleFilterData, setUpscaleFilterData] = useState<AvailableFaresFare[]>([]);
  const [upSaleToggle, setupSaleToggle] = useState(false);

  const removeDuplicateLegs = (fareArray: any) => {
    return fareArray.map((fareObj: any) => {
      const seenSegments = new Set<string>();
      const filteredLegs = fareObj.Fare.legs.filter((leg: any) => {
        const isDuplicate = leg.connections.some((connection: any) =>
          connection.segments.some((segment: any) => {
            const key = `${segment.flightNumber}-${segment.origin}-${segment.destination}`;
            if (seenSegments.has(key)) return true;
            seenSegments.add(key);
            return false;
          })
        );
        return !isDuplicate;
      });
      return { ...fareObj, Fare: { ...fareObj.Fare, legs: filteredLegs } };
    });
  };
  const UpscaleCalculation = useCallback((upscalePropertyArray: any[], propertyString: string) => {
    // Step 1: Prepare flight numbers grouped by leg
    const groupedFlightNumbers: Record<number, string[]> = upscalePropertyArray.reduce((acc, { codeNumber }) => {
      codeNumber.forEach(({ legNumber, flightNumber }: any) => {
        if (!acc[legNumber]) acc[legNumber] = [];
        acc[legNumber].push(flightNumber);
      });
      return acc;
    }, {} as Record<number, string[]>);
    

    const groupedFlightArray = Object.values(groupedFlightNumbers);
    setSearchFlightNumber(groupedFlightArray);

    // Step 2: Filter fares that match flight numbers
    const filteredData = props.TotalFare.filter(({ Fare }) => {
      if (Fare.fareIndex === upscalePropertyArray[0]?.fareIndex) return false;
      if (Fare.legs.length !== upscalePropertyArray.length) return false;

      return Object.entries(groupedFlightNumbers).every(([legIndex, flightNumbers]) => {
        const leg = Fare.legs[Number(legIndex)];
        if (!leg) return false;
        return leg.connections.some(conn =>
          flightNumbers.every(flightNo =>
            conn.segments.some(seg => seg.flightNumber === flightNo)
          )
        );
      });
    });

    // Step 3: Early exit if not found
    if (propertyString !== "connectionTriggeredLeg") {
      if (!filteredData.length) {
        toast.error("No upsell found", { autoClose: 1500 });
        setupSaleToggle(propertyString === 'connectionTriggered');
        return;
      }
      if (!showFlightTimes) ToggleFlightTimes();
      setupSaleToggle(propertyString === 'connectionTriggered' ? true : prev => !prev);
    } else if (!showFlightTimes) {
      ToggleFlightTimes();
    }

    // Step 4: Final filter with connection match + remove duplicate legs
    const finalUpsellData = removeDuplicateLegs(
      filteredData.filter(({ Fare }) =>
        Fare.legs.some((leg, i) => {
          const connIndex = findConnectionIndices(Fare, groupedFlightArray)[i];
          return leg.connections.some(c => c.index === connIndex);
        })
      )
    );
    setUpscaleFilterData(finalUpsellData);
  }, [
    props.TotalFare,
    showFlightTimes,
    ToggleFlightTimes,
    setupSaleToggle,
    removeDuplicateLegs,
    findConnectionIndices
  ]);

  const SelectedLegConnections = props.SelectedConnections ?? internalSelectedConnections;


  return (
    <div className={`row singlefare ${!ShowFare ? "d-none" : ""}`}>
      {!renderError ? (
        <Fragment>
          <div className={`col-12 col-md-9 p-0 ${OriginalFareIndex}`}>
            <div
              className={`fare__single_fare mb-0 mb-md-2 ${props.isScrollF === "isScrollState"
                ? props.fareLegBoolArray[props.FareData.fareIndex]?.fareLeg
                : showLegs ? "boxShadow-light mb-md-3" : ""}`}
            >
              <FareHeader
                ToggleFare={ToggleLegs}
                OriginalFareIndex={OriginalFareIndex}
                Data={props.FareData.fareHeader!}
                PlatingCarriers={DistinctPlatingCarriers}
                IsExpanded={props.isScrollF === "isScrollState"
                  ? props.fareLegBoolArray[props.FareData.fareIndex]?.fareLeg
                  : showLegs}
                TotalPrice={props.FareData.totalPrice}
                TotalTax={props.FareData.totalTax}
                Currency={props.FareData.currency!}
                Services={_addedServices}
                myRefs={props.myRefs!}
                FareIndex={props.FareData.fareIndex!}
                fareData={props.FareData}
              />

              {(props.isScrollF === "isScrollState"
                ? props.fareLegBoolArray[props.FareData.fareIndex]?.fareLeg
                : showLegs) && (
                  <>
                    <FareLegList
                      FareData={props.FareData}
                      internalSelectedConnections={internalSelectedConnections}
                      showFlightTimes={showFlightTimes}
                      SetSelectedConnection={SetSelectedConnection}
                      DistinctPlatingCarriers={DistinctPlatingCarriers}
                      Applicability={props.Applicability}
                      isActivate={props.isActivate}
                      ToggleFlightTimes={ToggleFlightTimes}
                      setStatus={setStatus}
                      upSaleToggle={upSaleToggle}
                      upscaleFilterData={upscaleFilterData}
                      GetSelectedConnectionIndexByLegIndex={GetSelectedConnectionIndexByLegIndex}
                      GetSelectedConnectionIndexByLegIndexUpsell={GetSelectedConnectionIndexByLegIndexUpsell}
                      responsive={responsive}
                      visibleItems={visibleItems}
                      scrollToBook={scrollToBook}
                    />

                    <FareCalculation
                      OriginalFareIndex={OriginalFareIndex}
                      Show={showCalculation}
                      Data={props.FareData.calculationResult!}
                      Currency={props.FareData.currency!}
                      AddedServices={_addedServices}
                      AssignalbePassengers={AssignablePassengers}
                    />
                    <FareActions
                      Fare={props.FareData}
                      BookFare={props.BookFare}
                      IsFareBooking={props.IsFareBooking}
                      SelectedConnections={internalSelectedConnections}
                      AddedServices={_addedServices}
                      OnSelectConnection={SetSelectedConnection}
                      ToggleFlightTimes={ToggleFlightTimes}
                      ToggleRulesModal={() => toggleModal("rules")}
                      ToggleAncillariesModal={() => toggleModal("ancillaries")}
                      ToggleFlightDetailsModal={() => toggleModal("flightDetails")}
                      ToggleCalculationDebug={() => toggleModal("calculationDebug")}
                      ToggleCalculation={() => setShowCalculation(prev => !prev)}
                      ShowCalcDebug={props.ShowCalcDebugger}
                      UpscaleCalculation={UpscaleCalculation}
                      upSaleToggle={upSaleToggle}
                      showLegs={props.isScrollF === "isScrollState"
                        ? props.fareLegBoolArray[props.FareData.fareIndex]?.fareLeg
                        : showLegs}
                      upscaleFilterData={upscaleFilterData}
                      setupSaleToggle={setupSaleToggle}
                      isFlightTimesOpen={showFlightTimes}
                    />

                  </>
                )}
            </div>
          </div>

          <FareInfoBox
            Info={props.FareData.fareInfoBox!}
            ShowDetails={props.isScrollF === "isScrollState"
              ? props.fareLegBoolArray[props.FareData.fareIndex]?.fareLeg
              : showLegs}
            ToggleFare={ToggleLegs}
            FareIndex={props.FareData.fareIndex}
            SelectedConnections={SelectedLegConnections}
            Legs={props.FareData.legs}
            Status={Status}
            travelHeader={props.FareData.travelHeaderMinSum}
          />

          <FareModals
            modals={modals}
            toggleModal={toggleModal}
            FareData={props.FareData}
            SelectedConnections={SelectedLegConnections}
            SetSelectedConnection={SetSelectedConnection}
            AddedServices={_addedServices}
            SetAddedServices={_setAddedServices}
            AssignablePassengers={AssignablePassengers}
            GetSelectedConnectionIndexByLegIndex={GetSelectedConnectionIndexByLegIndex}
            setStatus={setStatus}
          />
        </Fragment>
      ) : (
        <div className="col-12">
          <Alert color="danger">
            An error occurred. This fare cannot be displayed.
          </Alert>
        </div>
      )}
    </div>
  );
};

export default Fare;
